var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "luna") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RenBridge_v2-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "luna-icon",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "luna",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8190873,7.71242553 C17.5021724,6.9803617 17.5021724,6.9803617 9.01057669,3.91270213 C4.73615116,2.36891489 3.94300222,0.878361702 7.03670435,0.203744681 C7.18740648,0.171 7.33925754,0.142276596 7.49264052,0.117191489 C7.96561924,0.040212766 8.45123627,-2.39808173e-14 8.94604478,-2.39808173e-14 C13.4730448,-2.39808173e-14 17.2151299,3.3552766 17.8190873,7.71242553",
    id: "Fill-7",
    fill: "#F9D85E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8175746,7.70886383 C17.5707448,7.13860851 17.5079363,7.01145957 13.4292129,5.51535319 C14.290915,7.69431064 15.8096171,8.86028936 17.791915,10.3740128 C17.8658299,9.91099149 17.9043192,9.43609787 17.9043192,8.95201277 C17.9043192,8.5301617 17.8742554,8.11520426 17.8175746,7.70886383",
    id: "Fill-4",
    fill: "#EF7730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81261073,11.1893362 C5.91561073,9.44754894 3.48350435,5.91265532 3.34161073,2.35497447 C3.33548307,2.20484681 3.15701499,2.13016596 3.04403627,2.22935745 C1.16035542,3.88516596 -0.0220913933,6.31842128 0.000312861988,9.02761277 C0.0401426492,13.8512298 3.95878095,17.8112298 8.78584478,17.9027617 C12.6834192,17.9762936 16.0268235,15.5629532 17.3329724,12.1437191 C17.3846746,12.0087191 17.2646107,11.8691234 17.124249,11.9043574 C14.8537597,12.4753787 12.2617597,12.2840809 9.81261073,11.1893362",
    id: "Fill-1",
    fill: "#F9D85E"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuna);
export default __webpack_public_path__ + "static/media/luna.961bd2bb.svg";
export { ForwardRef as ReactComponent };